/*
  <kg-card-promo>: Aktionspreis auf der Produktkachel. Der Preis mit Code steht nicht im
  HTML, sondern wird erst nach der ersten Interaktion des Besuchers berechnet. Genau wie
  im Kaufbereich: Suchmaschinen sollen keinen zweiten Preis lesen, sonst weicht der
  ausgelesene Preis von dem im Produktdatenstrom ab.
*/

import { formatMoney } from './money.js';

/*
  Kein 'scroll' in der Liste: Nach einem Neuladen stellt der Browser die alte
  Scrollposition von selbst wieder her, das loest ein scroll-Ereignis aus, ohne dass
  jemand etwas getan hat. Echte Besucher erreicht man trotzdem, denn Mausrad, Finger,
  Zeiger und Tastatur stehen weiter in der Liste.
*/
const REVEAL_EVENTS = ['pointermove', 'pointerdown', 'touchstart', 'keydown', 'wheel'];
const isBot = () => Boolean(navigator.webdriver) || /bot|crawl|spider|slurp|lighthouse|headless/i.test(navigator.userAgent);

const MERKMAL = "kgInteracted";

/*
  Gemeinsames Merkmal am Dokument: Sobald irgendwo eine Eingabe kam, steht
  data-kg-interacted am html-Element. Nachgeladene Bereiche bringen ihr Skript erst
  danach mit und lesen daran ab, dass der Besucher laengst da war.
*/
const schonEingegeben = () => MERKMAL in document.documentElement.dataset;

function merken() {
  document.documentElement.dataset[MERKMAL] = "";
}

if (!isBot()) {
  REVEAL_EVENTS.forEach((type) => window.addEventListener(type, merken, { capture: true, passive: true, once: true }));
}

/* Alle Kacheln einer Seite warten auf dasselbe Signal, deshalb eine gemeinsame Liste */
const wartende = new Set();
let scharf = false;
/*
  Einmal aufgedeckt, bleibt aufgedeckt: Der Schnellkauf-Drawer wird erst nach dem Tippen
  nachgeladen, seine Box kaeme sonst nie dran, weil das Signal laengst vorbei ist. Auf dem
  Handy gibt es im Drawer ausserdem nichts zu scrollen, ein zweites Signal waere unwahrscheinlich.
*/
let aufgedeckt = false;

function aufdecken() {
  entschaerfen();
  aufgedeckt = true;
  for (const element of wartende) element.zeichnen();
  wartende.clear();
}

function entschaerfen() {
  if (!scharf) return;
  REVEAL_EVENTS.forEach((type) => window.removeEventListener(type, aufdecken, { capture: true }));
  scharf = false;
}

function scharfmachen() {
  if (scharf) return;
  REVEAL_EVENTS.forEach((type) => window.addEventListener(type, aufdecken, { capture: true, passive: true }));
  scharf = true;
}

class KgCardPromo extends HTMLElement {
  connectedCallback() {
    this.feld = this.querySelector('[data-card-promo-price]');
    this.preis = Number(this.dataset.price || 0);
    this.prozent = Number(this.dataset.percent || 0);
    if (!this.feld || !this.preis || !this.prozent) {
      this.hidden = true;
      return;
    }
    if (isBot()) return;
    if (aufgedeckt || schonEingegeben()) {
      this.zeichnen();
      return;
    }
    wartende.add(this);
    scharfmachen();
  }

  disconnectedCallback() {
    wartende.delete(this);
    if (!wartende.size) entschaerfen();
  }

  zeichnen() {
    const rabattiert = Math.round((this.preis * (100 - this.prozent)) / 100);
    this.feld.textContent = formatMoney(rabattiert, this.dataset.moneyFormat, this.dataset.currency, document.documentElement.lang);
    this.dataset.visible = 'true';
  }
}

customElements.define('kg-card-promo', KgCardPromo);
